<template>
  <div>
    <BaseTable
      :tableTitle="$t('nav.robot_list')"
      :label-data="columns"
      :table-data="info.tableData"
      :counts="info.count"
      :current-page="info.searchParams.page"
      :page-size="info.searchParams.limit"
      :loading="info.listLoading"
      @size-change="handleSizeChange"
      @page-change="handleCurrentChange"
    >
      <template slot="firstColumn">
        <el-table-column prop="robot_name" :label="$t('robot.robot_name')" min-width="212">
          <template slot-scope="scope">
            <BaseTooltip :text="scope.row.robot_name"></BaseTooltip>
          </template>
        </el-table-column>
        <el-table-column min-width="180">
          <template #header>
            <div class="flex-center">
              <span>{{ $t('robot.robotId') }}</span>
              <el-tooltip class="item" effect="dark" placement="right-start">
                <div slot="content">
                  {{ $t('robot.idDesc') }}
                </div>
                <i class="iconfont icon-jieshi-xian question-icon"></i>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            <BaseTooltip :text="scope.row.robot_id_hash"></BaseTooltip>
          </template>
        </el-table-column>
      </template>

      <el-table-column prop="IntentionList" :label="$t('robot.state')" min-width="78">
        <template slot-scope="scope">
          <BaseStatusBadge v-show="scope.row.status === 1" status="success" :text="$t('robot.valid')"></BaseStatusBadge>
          <BaseStatusBadge v-show="scope.row.status === 0" status="offline" :text="$t('robot.invalid')"></BaseStatusBadge>
        </template>
      </el-table-column>
      <el-table-column prop="IntentionList" :label="$t('execall.operation')" min-width="192px">
        <template slot-scope="scope">
          <div class="actions">
            <button @click="handleAudition(scope.row)" class="oppbtn" v-if="scope.row.records && scope.row.records.length > 0" v-log="{ page_event: 'c_audition_record' }">
              <i class="iconfont icon-shiting" style="color: #8b8e9a; font-size: 12px"></i>
              {{ $t('robot.auditionRecord') }}
            </button>
            <button v-if="info.searchParams.robot_type == 'normal' && scope.row.robot_method == 'single'" @click="handleViewDetails(scope.row)" class="oppbtn" v-log="{ page_event: 'c_view_detail' }">
              {{ $t('robot.detail') }}
            </button>
            <button v-if="info.searchParams.robot_type == 'ivr'" @click="handleViewDetails(scope.row)" class="oppbtn" v-log="{ page_event: 'c_view_detail' }">{{ $t('robot.detail') }}</button>
            <button @click="handleEditRemark(scope.row)" class="oppbtn" v-log="{ page_event: 'c_edit_remark' }" v-hasPermi="['*RobotList*edit_remark*']">{{ $t('robot.edit_remark') }}</button>
          </div>
        </template>
      </el-table-column>
    </BaseTable>
  </div>
</template>

<script>
import BaseStatusBadge from '@/components/common/BaseStatusBadge.vue'

export default {
  name: 'RobotTable',
  props: {
    type: String, // normal / ivr
    info: Object
  },
  components: {
    BaseStatusBadge
  },
  data() {
    return {
      columns: [
        { label: this.$t('robot.remark'), prop: 'remark', minWidth: 177 },
        { label: this.$t('robot.tone'), prop: 'tone', minWidth: 100 },
        { label: this.$t('robot.robotGender'), prop: 'gender', minWidth: 80, formatter: this.genderFormatter },
        { label: this.$t('robot.create_time'), prop: 'create_time', minWidth: 100 },
        { label: this.$t('robot.update_time'), prop: 'update_time', minWidth: 100 }
      ]
    }
  },
  methods: {
    genderFormatter(row) {
      const { gender } = row
      let genderStr = ''
      switch (gender) {
        case 1:
          genderStr = this.$t('account.male')
          break

        case 2:
          genderStr = this.$t('account.female')
          break

        default:
          break
      }
      return genderStr
    },
    handleViewDetails(row) {
      this.$store.commit('SET_DETAIL_BREADCRUMB_LIST', [
        { routeName: this.$route.name, name: 'nav.robot_list' },
        { routeName: '', name: 'robot.detail' }
      ])
      this.$store.commit('SET_CURRENT_ROBOT', {
        robot_id: row.robot_id,
        robot_name: row.robot_name,
        type: row.actionable
      })
      this.$router.push({
        name: sessionStorage.getItem('activeName') + 'RobotDetail',
        query: {
          robot_id: row.robot_id,
          robot_name: row.robot_name,
          type: row.actionable
        }
      })
    },
    handleSizeChange(val) {
      this.$emit('size-change', val, this.type)
    },
    handleCurrentChange(val) {
      this.$emit('current-change', val, this.type)
    },
    handleAudition(row) {
      this.$emit('audition', row)
    },
    handleEditRemark(row) {
      this.$emit('remark', row)
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-center {
  display: flex;
  align-items: center;

  .question-icon {
    font-weight: normal;
    margin-left: 4px;
    color: #8b8e9a;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Robot/components/RobotTable.vue